

//設定箇所 start
var minDay = 1;//現在日時からこの数値をプラスして選択可能な最短日数 本日が1/1で設定が1なら最短は1/2
var maxListSize = 59;//最短日数から起算して選択可能な最大日数 本日が1/1で設定が10なら最大日は1/10　締め時間,不可曜日,不可日付があった場合、最大リストから除去する形になる
                     //※注意点 数値を伸ばし過ぎると閲覧者の利用端末によっては動作が重くなります 100以内に収めてください
var limitTime = "23:59"; //受注締め時間 これを跨いだ場合minDayに1日加算されます 未設定は"23:59"にする
var timezoneoffset = -9; // UTC-表示したいタイムゾーン(単位:hour) JSTなら-9
var WeekChars = [ "日", "月", "火", "水", "木", "金", "土" ];
var noSendWeekDaylist = ['']; //選択不可能な曜日 生成したリストから該当の曜日を除去して表示 ''で曜日を囲み複数ある場合はカンマで繋ぐ
//var noSendWeekDaylist = ['日','月','火','水','木','金','土']; //設定サンプル
var noSendDaylist = ['']; //選択不可能な日YY/MM形式で指定 生成したリストから該当の日を除去して表示 ''で日を囲み複数ある場合はカンマで繋ぐ
//var noSendDaylist = ['01/05','06/13']; //サンプル
var pullDownAddWeekDay = true;//日付選択プルダウンに曜日を追加して表示 trueなら表示falseなら非表示
var pullDownAddHead = true;//日付選択に"指定無し"を追加する trueなら表示falseなら非表示
var pullDownAddHeadtxt = "指定なし";//指定をしない際のテキスト・value値
var pullDownAddYear = true;//日付選択に年を追加する trueなら表示falseなら非表示

//出荷準備できる営業日確保のため選択肢のカウントに含めたくない曜日と日付
var noBusinessWeekDaylist = ['']; //営業日にカウントしない曜日 生成したリストから該当の曜日を除去して表示 ''で曜日を囲み複数ある場合はカンマで繋ぐ
var noBusinessDaylist = ['']; //営業日にカウントしない日YY/MM形式で指定 生成したリストから該当の日を除去して表示 ''で日を囲み複数ある場合はカンマで繋ぐ

//配送日候補日のリストの表示上限値
//（maxListSizeの数字だけだと、maxListSizeの設定日から除外曜日・日時を抜いていくので祝日が多いと候補日が減ってしまう。表示上限値を設けて上限に達したらpushをやめる）
var maxDeliveryDaylist = 60;


//設定箇所 end
//設定したタイムゾーンに併せた現在日時を取得
//var fakeUTC = new Date(Date.now() - (timezoneoffset * 60 - new Date().getTimezoneOffset()) * 60000); 
var fakeUTC = new Date(Date.now() + (new Date().getTimezoneOffset() - timezoneoffset * 60) * 60000); // WEB_0001-26746　不具合修正
var year = fakeUTC.getFullYear();
var month = fakeUTC.getMonth()+1;
var date = fakeUTC.getDate();
var hour = fakeUTC.getHours();
var min = fakeUTC.getMinutes();
var second = fakeUTC.getSeconds();


var CURRENT_PATH = document.getElementById('originalDeliveryDate').src.replace(new RegExp('^'+location.origin), '').replace(/[^\/]+$/, '');

//起動
window.addEventListener('DOMContentLoaded', function(){
  // WEB_0001-26746: 店舗受取カート（#pickupDate が存在）では配送用処理を実行しない。
  // 配送用要素（#deliveryDate 等）が存在せず null 参照エラーになるのを防ぐガード。
  if(document.getElementById('pickupDate') || !document.getElementById('deliveryDate')){
    return;
  }

  //配送希望日変更時の更新
  $("#deliveryDate").on("change",function(){
    updateCartAttributes("shipping_day");
  });
  //配送時間帯変更時の更新
  $("#deliveryTime").on("change",function(){
    updateCartAttributes("shipping_time");
  });

  //購入不可の場合
  if( !isPurchase ){
    //プルダウンの作成
    var selectList = [];
    createPullDown(selectList);
    return;
  }else {
    //最短日付を取得
    var mimDay = getMinDay();

    //リストを作成
    var selectList = createList(mimDay);
    if(noSendWeekDaylist.length > 0){//指定不可能な曜日の選択があればリストから削除
      selectList = delSendWeekDay(selectList);
    }
    if(noSendDaylist.length > 0){//指定不可能な日付の指定があればリストから削除
      selectList = delSendDay(selectList);
    }

    //出荷準備するために確保する営業日
    var delCount = deleteBusinessDays();
    selectList = delDay(selectList,delCount,noBusinessWeekDaylist,noBusinessDaylist,maxDeliveryDaylist,mimDay);

    //プルダウンの作成
    createPullDown(selectList);
  }
})

//出荷準備するために確保する営業日
function deleteBusinessDays(){
  var delCount;
  if( deliveryDate === false ){
    delCount = 999;
  }else {
    delCount = deliveryDate;
  }
  return delCount;
}

//最短日付を取得
function getMinDay(){
  var today = getToday();//現在日の取得
  var now = getNow();//現在日時の取得
  try {//配送締め時間の取得
  var deadlineHour = limitTime.split(':')[0];
  var deadlineMinute = limitTime.split(':')[1];
  var deadlineTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), deadlineHour, deadlineMinute);
  } catch(e) {
  deadlineTime = today;//指定方法に不備があった場合は現在日時が締め時間
  }
  if(now.getTime() > deadlineTime.getTime()){//締め時間を超えた場合に1日加算
  minDay++;
  }
  var mimDay = new Date(now.setDate(now.getDate() + minDay));//最短日付
  return mimDay;
}

//出荷準備するために確保する営業日を加味して、リストを作成
function delDay(selectList,delCount,noBusinessWeekDaylist,noBusinessDaylist,maxDeliveryDaylist,mimDay){
  var delAfterList = [];
  var delDayResult = [];
  var businessList = [];//営業日リスト
  var delLimit = delCount;
  var skipFg = false;
  var wDay= "";//曜日
  var noSendDay;
  var targetDay;
  var muchFlg;
  var mimBusinessDay = new Date(mimDay);
  mimBusinessDay.setDate( mimDay.getDate() + (delCount-1) );//営業日を加味した日の翌日日付
  
  for (var i=0; i< selectList.length; i++) {
    skipFg = false;
    muchFlg = false;
    wDay= selectList[i].getDay();//曜日の取得
    WeekChars[wDay];
    targetDay = new Date(2001+'/'+(selectList[i].getMonth()+1)+'/'+selectList[i].getDate());//月日
    
    //営業日として加味しない曜日であれば、営業日加算の処理をスキップ
    for(var j=0; j< noBusinessWeekDaylist.length; j++){
      if(WeekChars[wDay] == noBusinessWeekDaylist[j]){
      skipFg = true;
     }
    }
    //営業日として加味しない日付であれば、営業日加算の処理をスキップ
    for(var j=0; j< noBusinessDaylist.length; j++){
      noSendDay = new Date(2001+'/'+noBusinessDaylist[j]);
      if(targetDay.getTime() == noSendDay.getTime()){
        skipFg = true;
      }
    }
    
    if(!skipFg){
      if(delLimit > 0){
        //最短日が日付リスト内に含んでいれば
        if(selectList[0].getTime() <= mimDay.getTime()){
          businessList.push(selectList[i]);//営業日として計上
        }else{
          //営業日を加味した日の翌日日付が日付リスト以前の場合（以前：その日も含む）
          if( selectList[i].getTime() < mimBusinessDay.getTime() ){
            businessList.push(selectList[i]);//営業日として計上
          }
        }
        delLimit = delLimit-1;
      }
    }
  }
    
  //営業日の末日を開始日付として設定
  if( businessList.length ){
    var startDay = new Date(2001+'/'+(businessList[businessList.length-1].getMonth()+1)+'/'+businessList[businessList.length-1].getDate());//指定営業日分を経過した分が開始日付
  }else{
    return selectList;
  }
  var startAfterFlg = false;//開始日以降のフラグ
  for (var i=0; i< selectList.length; i++) {
    if((new Date(2001+'/'+(selectList[i].getMonth()+1)+'/'+selectList[i].getDate())).getTime() == startDay.getTime()){
      startAfterFlg = true;
    }
    if(startAfterFlg){
      delAfterList.push(selectList[i]);
    }
  }

  for (var i=0; i< delAfterList.length; i++) {//delAfterListをループする
  if(i < maxDeliveryDaylist){//delAfterListの数がmaxDeliveryDaylistより少なければ
    delDayResult.push(delAfterList[i]);//delDayResultという配列にカウント用変数iを格納する
    }
  }
  
  return delDayResult;

}

//リストから配送日指定不可能な指定の曜日を除去する
function delSendWeekDay(selectList){
 var delAfterList = [];
 var skipFlg=false;//初期値
 for (var i=0; i< selectList.length; i++) {
  skipFlg=false;//初期化
  var wDay= selectList[i].getDay();//曜日の取得
   WeekChars[wDay];
   for(var j=0; j< noSendWeekDaylist.length; j++){
      if(WeekChars[wDay] == noSendWeekDaylist[j]){
        skipFlg=true;
      }
   }
   if(!skipFlg){
      delAfterList.push(selectList[i]);
   }
 }
  return delAfterList;
 }

//リストから配送日指定不可能な指定日付の除去
function delSendDay(selectList){
  var delAfterList = [];
  var noSendDay;
  var targetDay;
  var skipFlg=false;
  for (var i=0; i< selectList.length; i++) {
    skipFlg=false;
    targetDay = new Date(2001+'/'+(selectList[i].getMonth()+1)+'/'+selectList[i].getDate())
    for(var j=0; j< noSendDaylist.length; j++){
      noSendDay = new Date(2001+'/'+noSendDaylist[j]);
      if(targetDay.getTime() == noSendDay.getTime()){
          skipFlg=true;
      }
    }
    if(!skipFlg){
      delAfterList.push(selectList[i]);
    }
  }
  return delAfterList;
}

//基本日付リストの作成
function createList(minDay){
  var selectList = [];
  var targetDay = minDay;
  var maxSizeDay = 0;
  // maxListSizeに出荷準備営業日を足したものを最長指定日とする
  if(deliveryDate !== false) {
    maxSizeDay = parseInt(maxListSize) + parseInt(deliveryDate);
  }

  for (var i=0; i< maxSizeDay; i++) {
   targetDay = new Date(minDay);
   targetDay = new Date(targetDay.setDate(targetDay.getDate() + i));
   selectList.push(targetDay);
  }
  return selectList;
}
//現在日の取得(タイムゾーンで指定された日)
function getToday(){
  var today = new Date(year+"/"+month+"/"+date);
  return today;
}
//現在日時の取得(タイムゾーンで指定された時間)
function getNow(){
  var now = new Date(year+"/"+month+"/"+date+" "+hour+":"+min);
  return now;
}
//プルダウンに曜日追加
function pullDownAddWeekDay(){
  //曜日追加
  var w = ["日","月","火","水","木","金","土"];
  var deliveryDateSelectOption = $('select#SEND_HOPE_DATE option');
  for (var i=0; i<=deliveryDateSelectOption.length; i++) {
      if(i!=0){
          var optDatext = $(deliveryDateSelectOption[i]);
          var optionDateWeekDay = new Date($(optDatext).text());
          var optionDateWeekDayW = w[optionDateWeekDay.getDay()];
          $(optDatext).text( $(optDatext).text()+" ("+optionDateWeekDayW+")");
          }
      }
}
//プルダウンの作成
function createPullDown(selectList){
  var targetDate;
  var wDay='';
  var targetWeekDay = '';
  var select = document.getElementById('deliveryDate');
  var defaultVal = document.getElementById('dumyDeliveryDate').value;
  var option = document.createElement('option');
  var isNoMatchDate = true;
  if(pullDownAddHead){//指定なし
    option.setAttribute('value', pullDownAddHeadtxt);
    option.innerHTML = pullDownAddHeadtxt;
    select.appendChild(option);
  }
  for(var i=0; i< selectList.length; i++){
    option = document.createElement('option');
    targetDate='';
    targetWeekDay='';
    targetDate = ketaume((selectList[i].getMonth()+1),2)+'-'+ ketaume(selectList[i].getDate(),2);
    option.setAttribute('value', selectList[i].getFullYear()+'-'+targetDate);//valueをセット yyyy-mm-dd形式
    targetDate=targetDate.replace(/-/g,'/');
     if(pullDownAddYear){//年を追加する場合
      targetDate = selectList[i].getFullYear()+'/'+targetDate;
    }
    if(pullDownAddWeekDay){//曜日を追加する場合
      wDay= selectList[i].getDay();
      targetDate=targetDate+" ("+WeekChars[wDay]+")";
    }
    option.innerHTML = targetDate;
    // 日付選択済の場合の処理
    if(option.value == defaultVal){
      option.selected = true;
      isNoMatchDate = false;
    }
    select.appendChild(option);
  }
  // 選択済の日付が選択可能な日付リストに存在しない場合
  if(isNoMatchDate) {
    //配送希望日を指定なしに強制変更
    updateCartAttributes('shipping_day',pullDownAddHeadtxt);
  }
}
//桁埋めを行う
function ketaume(num,digit){
  if(digit < 1)
      return num; 
  var ketaumeStr = '0';
  var zero = '';
  
  for(var i=1; i<digit; i++){
      zero += ketaumeStr;
  }
  var result = ( zero + num ).slice( -digit );
  return result;
}

//cart attributes 更新処理
function updateCartAttributes(target,value){
    var selected = $(`[name="attributes\[${target}\]"]`);
    var setAttrValue;
    if( value !==undefined && value !=='') {
      setAttrValue = value;
    } else {
      setAttrValue = selected.val();
    }
    var formData ={
      attributes: {
        [target]: setAttrValue
      }
    };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: "no-store",
    body: JSON.stringify(formData)
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error("通信失敗");
    }
    return;
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('カート情報の更新に失敗しました。ページを再読み込みしてください。');
    return;
  });
}
function clearCartAttributes(){
    var formData ={
      attributes: {
        ['shipping_day']: '指定なし',
        ['shipping_time']: '指定なし'
      }
    };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: "no-store",
    body: JSON.stringify(formData)
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error("通信失敗");
    }
    return;
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('カート情報の更新に失敗しました。ページを再読み込みしてください。');
    return;
  });
}
